module.exports = __webpack_public_path__ + "img/logo.273aa35d.png";